
import { defineComponent, reactive, toRefs } from "vue";
import AliCaptcha from "./components/AliCaptcha.vue";
import { postCaptchaResultToFlutter } from "./utils/flutterBridge";

/** 后端提供的 appId，与 initAlicom4 的 captchaId 一致；Flutter 二次校验时一并带给后端 */
const CAPTCHA_ID = "472eb956dbbb1c0abdfdbf2ccfa36733";

export default defineComponent({
  name: "App",
  components: {
    AliCaptcha,
  },
  setup() {
    const data = reactive({
      captchaConfig: {
        config: {
          captchaId: CAPTCHA_ID,
          language: "zho",
          product: "bind",
          rem: 0.8,
        },
        handler: captchaHandler,
      },
    });

    /** 用户端验证成功：只把 getValidate() 结果交给 Flutter，由 Flutter 请求后端二次校验 */
    function deliverValidateToFlutter() {
      const captchaObj = (
        window as unknown as { captchaObj?: { getValidate: () => unknown } }
      ).captchaObj;
      if (!captchaObj) {
        postCaptchaResultToFlutter({
          ok: false,
          stage: "client",
          message: "captcha not initialized",
        });
        return;
      }
      const result = captchaObj.getValidate() as
        | Record<string, string>
        | false
        | null;
      if (!result) {
        postCaptchaResultToFlutter({
          ok: false,
          stage: "client",
          message: "请先完成验证",
        });
        return;
      }

      postCaptchaResultToFlutter({
        ok: true,
        stage: "client_validate",
        captchaId: CAPTCHA_ID,
        validate: result,
      });
    }

    function captchaHandler(captchaObj: any) {
      (window as unknown as { captchaObj: typeof captchaObj }).captchaObj =
        captchaObj;
      captchaObj
        .appendTo("#captcha")
        .onReady(function () {
          if (data.captchaConfig.config.product === "bind") {
            captchaObj.showCaptcha();
          }
        })
        .onNextReady(function () {
          /* optional */
        })
        .onError(function (e: unknown) {
          postCaptchaResultToFlutter({
            ok: false,
            stage: "captcha",
            detail: e,
          });
        })
        .onClose(function () {
          postCaptchaResultToFlutter({
            ok: false,
            stage: "user_close",
            message: "用户关闭了验证码弹窗",
          });
        })
        .onSuccess(function () {
          deliverValidateToFlutter();
        });
    }

    return {
      ...toRefs(data),
    };
  },
});
